import type { HubUserMeResponse, SocialAccountDto } from "@cede/types";

/**
 * Checks if user has exchange accounts connected
 */
export function hasExchangeAccounts(hubUser?: HubUserMeResponse): boolean {
  return (hubUser?.exchangeAccounts?.length ?? 0) > 0;
}

/**
 * Checks if user has social accounts connected
 */
export function hasSocialAccounts(socialAccounts: SocialAccountDto[]): boolean {
  return socialAccounts.length > 0;
}

/**
 * Checks if user is eligible to trade (has both CEX and social accounts)
 */
export function isEligibleToTrade(hubUser?: HubUserMeResponse, socialAccounts: SocialAccountDto[] = []): boolean {
  return hasExchangeAccounts(hubUser) && hasSocialAccounts(socialAccounts);
}
